import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";

import { useMaterialUIController, setLayout } from "context";

function TailwindLayout({ children }) {
    const [controller, dispatch] = useMaterialUIController();
    const { miniSidenav } = controller;
    const { pathname } = useLocation();

    useEffect(() => {
        setLayout(dispatch, "dashboard");
    }, [pathname]);

    return (
        <div
            className={`relative bg-slate-100 transition-all ease-in-out duration-300 ${miniSidenav ? "xl:ml-[120px]" : "xl:ml-[256px]"
                }`}
        >
            {children}
        </div>
    );
}

TailwindLayout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default TailwindLayout;
